<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <div class="board_search_wrap">
                            <div class="monitoring_menu">
                                <ul>
                                    <li :class="state.filterData.sns?.length === snsList.length ? 'active' : ''">
                                        <p>전체</p>
                                        <p>{{ list.cntData?.cntAll?.toLocaleString() ?? 0 }} 건 검색</p>
                                        <p>{{ list.cntData?.cntResultAll?.toLocaleString() ?? 0 }}</p>
                                    </li>
                                    <li
                                        v-for="item in snsList"
                                        :class="state.filterData.sns?.length === 1 && item.idx === state.filterData.sns[0] ? 'active' : ''"
                                    >
                                        <p>{{ item.title }}</p>
                                        <p>
                                            <template v-if="item.idx === 1">
                                                {{ list.cntData?.cntX?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 2">
                                                {{ list.cntData?.cntGoogle?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 3">
                                                {{ list.cntData?.cntNaver?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 4">
                                                {{ list.cntData?.cntYoutube?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 5">
                                                {{ list.cntData?.cntInstagram?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 6">
                                                {{ list.cntData?.cntBluesky?.toLocaleString() ?? 0 }}
                                            </template>
                                            건 검색
                                        </p>
                                        <p>
                                            <template v-if="item.idx === 1">
                                                {{ list.cntData?.cntResultX?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 2">
                                                {{ list.cntData?.cntResultGoogle?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 3">
                                                {{ list.cntData?.cntResultNaver?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 4">
                                                {{ list.cntData?.cntResultYoutube?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 5">
                                                {{ list.cntData?.cntResultInstagram?.toLocaleString() ?? 0 }}
                                            </template>
                                            <template v-else-if="item.idx === 6">
                                                {{ list.cntData?.cntResultBluesky?.toLocaleString() ?? 0 }}
                                            </template>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <Filter
                                :sns="true"
                                :resultType="false"
                                :resultDetailType="false"
                                :nation="false"
                                :isMonitoring="false"
                                :selectOption="state.selectOption"
                                @search="filterSearch"
                                @reset="filterSearch"
                            ></Filter>
                        </div>
                        <div class="board_top">
                            <div class="board_top_btns">
                                <button type="button" class="board_btn" @click="deleteLists">선택삭제</button>
                                <button type="button" class="board_btn board_ico_btn" @click="excelDownLoad">
                                    <span>엑셀다운로드</span>
                                    <img src="@/assets/board/excel_ico.png" alt="" />
                                </button>
                            </div>
                            <div class="count">
                                총
                                <span>{{ numberFormat(state.totalLength) }}건</span>
                            </div>
                        </div>
                        <div class="board_list">
                            <table class="board_table">
                                <colgroup>
                                    <col width="3%" />
                                    <col width="4%" />
                                    <col width="6%" />
                                    <col width="10%" />
                                    <col width="10%" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="auto" />
                                    <col width="4%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.checkAll" @change="checkAllList()" />
                                                <span></span>
                                            </label>
                                        </th>
                                        <th>연번</th>
                                        <th>담당자</th>
                                        <th>검색유형</th>
                                        <th>검색키워드</th>
                                        <th>검색이미지</th>
                                        <th>검색 플랫폼</th>
                                        <th>검색일시</th>
                                        <th>검색종료일</th>
                                        <th>검색진행률</th>
                                        <th>구분</th>
                                        <th>검색결과</th>
                                        <th>삭제</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!state.isLoading">
                                    <tr v-for="(item, idx) in list.data">
                                        <td>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.checkList" :value="item.idx" />
                                                <span></span>
                                            </label>
                                        </td>
                                        <td>{{ item.idx }}</td>
                                        <td>
                                            {{ item.meName }}
                                        </td>
                                        <td>{{ item.strType }}</td>
                                        <td>
                                            <span :class="item.keyword.length > 12 ? 'more_txt' : ''" @click="moreText(item.keyword)">
                                                {{ item.keyword }}
                                            </span>
                                        </td>
                                        <td>
                                            <div class="board_thumb" v-if="item.imgPath">
                                                <img :src="item.imgPath" alt="" @click="showImg(item.imgPath)" />
                                            </div>
                                        </td>
                                        <td>
                                            <div class="pop_sns_box">
                                                <span v-if="item.isTwitter === 1"><img src="@/assets/sns/Twitter.png" /></span>
                                                <span v-if="item.isBluesky === 1"><img src="@/assets/sns/Bluesky.png" /></span>
                                                <span v-if="item.isGoogle === 1"><img src="@/assets/sns/Google.png" /></span>
                                                <span v-if="item.isNaver === 1"><img src="@/assets/sns/Naver.png" /></span>
                                                <span v-if="item.isYoutube === 1"><img src="@/assets/sns/Youtube.png" /></span>
                                                <span v-if="item.isInstagram === 1"><img src="@/assets/sns/Instagram.png" /></span>
                                            </div>
                                        </td>
                                        <td>
                                            {{ formatDate(item.createDate) }}
                                        </td>
                                        <td class="col_spinner">
                                            <template v-if="item.analysisCompDate">{{ formatDate(item.analysisCompDate) }}</template>
                                            <template v-else>
                                                <Spinner></Spinner>
                                            </template>
                                        </td>
                                        <td>
                                            <span>
                                                {{ item.progress ? item.progress : 0 }}%
                                                <br />
                                                {{ item.progress < 100 ? "분석중" : "처리완료" }}
                                            </span>
                                        </td>
                                        <td>
                                            <button type="button" class="blue_btn" @click="resultBtn(item.idx)">검색결과</button>
                                        </td>
                                        <td>
                                            <div class="search_txt_box">
                                                <span class="total_count">
                                                    총
                                                    {{ item.cntResult ? numberFormat(item.cntResult) : 0 }}
                                                    건 (
                                                    {{ item.currentPaging }} /
                                                    {{ item.cntTotalPaging }}
                                                    )
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <button type="button" class="delete_btn">
                                                <img src="@/assets/board/delete_ico.png" alt="" @click="deleteList(item.idx)" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="list.data.length === 0 && !state.isLoading">
                                    <tr>
                                        <td colspan="14">
                                            <NoResult></NoResult>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="state.isLoading">
                                    <tr>
                                        <td colspan="14">
                                            <Spinner></Spinner>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <PageBtn
                            v-if="list.data.length !== 0 && !state.isLoading"
                            :currentPage="state.currentPage"
                            :totalLength="state.totalLength"
                            :perPage="state.perPage"
                            @onPaging="handlePageChange"
                        ></PageBtn>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Popup :show="state.isModalOpen" :title="modal.title" :content="modal.content" @close="modalClose"></Popup>
</template>
<script lang="ts">
    import {
        apiService,
        globalStore,
        Header,
        Menu,
        onMounted,
        reactive,
        dateFormat,
        formatDate,
        router,
        userStore,
        numberFormat,
        NoResult,
        PageBtn,
        returnCode,
        Filter,
        Spinner,
        inject,
        searchFilter,
        searchCnt,
    } from "@/BaseComponent";
    import Popup from "@/components/popup.vue";
    export default {
        props: [],
        components: {
            Header,
            Menu,
            Popup,
            NoResult,
            PageBtn,
            Filter,
            Spinner,
        },
        setup() {
            const author = inject("author") as any;
            const global: any = globalStore();
            const user: any = userStore();
            const { changeCode } = returnCode();
            const state = reactive({
                isLoading: true as boolean,
                selectOption: [
                    { idx: 1, text: "연번" },
                    { idx: 2, text: "키워드" },
                    { idx: 3, text: "담당자", clfCd: 99 },
                ] as Array<any>,
                filterData: {} as searchFilter,
                checkList: [] as Array<number>,
                checkAll: false as boolean,
                selectStatus: 0 as number,
                perPage: 100 as number,
                totalLength: 0 as number,
                currentPage: 1 as number,
                totlapage: 1 as number,
                isModalOpen: false as boolean,
            });
            const modal = reactive({
                title: "" as string,
                content: {
                    title: "" as string,
                    main: {
                        data: "" as any,
                        class: "desc",
                        render: (data: any) => {
                            return `<p>${data}</p>`;
                        },
                    } as any,
                    subTitle: "" as string,
                    sub: {
                        data: "" as any,
                        class: "pop_sns_box",
                        render: (data: any) => {
                            return `
                                <span style="display:${data.twitter === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/Twitter.png")}"></span>
                                <span style="display:${data.bluesky === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/Bluesky.png")}"></span>
                                <span style="display:${data.google === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/Google.png")}"></span>
                                <span style="display:${data.naver === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/Naver.png")}"></span>
                                <span style="display:${data.youtube === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/Youtube.png")}"></span>
                                <span style="display:${data.instagram === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/Instagram.png")}"></span>
                            `;
                        },
                    } as any,
                    img: {
                        data: "" as any,
                        render: (data: any) => {
                            return data ? data : `<img src="${require("@/assets/common/NoImg.png")}" alt="이미지 없음" />`;
                        },
                    } as any,
                },
            });
            const list = reactive({
                selectDate: [] as any,
                data: [] as Array<any>,
                cntData: {} as searchCnt,
            });

            const snsList = [
                { idx: 1, title: "X", key: "X" },
                { idx: 6, title: "블루스카이", key: "Bluesky" },
                { idx: 2, title: "구글", key: "google" },
                { idx: 3, title: "네이버", key: "naver" },
                { idx: 4, title: "유튜브", key: "youtube" },
                { idx: 5, title: "인스타그램", key: "instargram" },
            ];

            onMounted(() => {
                const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                const endDate = new Date();
                list.selectDate = [startDate, endDate];
                global.setSelectMenu(1);
            });

            const getSearchList = async () => {
                state.isLoading = true;

                const res = await apiService.search.getList(
                    state.currentPage,
                    state.perPage,
                    state.filterData.searchType,
                    dateFormat(new Date(state.filterData.date[0])),
                    dateFormat(new Date(state.filterData.date[1])),
                    state.filterData.type.join(","),
                    state.filterData.searchContent,
                    state.filterData.sns,
                );
                if (res.returnCode === 0) {
                    list.data = res.list.data;
                    state.totlapage = res.list.totlapage;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    alert(changeCode(res.returnCode));
                }
                state.isLoading = false;
            };

            const getSearchCnt = async () => {
                const param = {
                    startDate: dateFormat(new Date(state.filterData.date[0])),
                    endDate: dateFormat(new Date(state.filterData.date[1])),
                };
                const res = await apiService.search.getSearchCnt(param);
                if (res.returnCode === 0) {
                    list.cntData = res.data;
                }
            };

            const deleteList = async (idx: number) => {
                if (confirm("검색이력을 삭제하시겠습니까?")) {
                    const res = await apiService.search.deleteList(idx);
                    if (res.returnCode === 0) {
                        alert("삭제 완료되었습니다.");
                        getSearchList();
                    } else if (res.returnCode !== 11) {
                        return alert(changeCode(res.returnCode));
                    }
                }
            };

            const deleteLists = async () => {
                if (state.checkList.length > 0) {
                    if (confirm("검색이력을 삭제하시겠습니까?")) {
                        const res = await apiService.search.deleteLists(state.checkList.join(", "));
                        if (res.returnCode === 0) {
                            alert("삭제 완료되었습니다.");
                            getSearchList();
                        } else if (res.returnCode !== 11) {
                            return alert(changeCode(res.returnCode));
                        }
                    }
                } else {
                    return alert("선택된 목록이 없습니다.");
                }
            };

            const searchList = () => {
                getSearchList();
            };

            const selectDate = (date: any) => {
                list.selectDate = date;
                global.setSearchDate(date);
            };

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getSearchList();
            };

            const resultBtn = (idx: number) => {
                router.push(`/search/result/${idx}`);
            };

            const moreText = (keyword: any) => {
                if (keyword.length > 12) {
                    modal.title = "검색키워드";
                    modal.content.title = "";
                    modal.content.main.data = keyword;
                    modal.content.subTitle = "";
                    state.isModalOpen = true;
                }
            };

            const modalClose = () => {
                modal.content.img.data = "";
                state.isModalOpen = false;
            };

            const filterSearch = (data: searchFilter) => {
                state.currentPage = 1;
                state.filterData = data;
                getSearchList();
                getSearchCnt();
            };

            const excelDownLoad = async () => {
                let checkedIdx = state.checkList.length > 0 ? state.checkList : null;
                let type1 = [] as Array<number>;
                if (state.filterData.type[1]) type1.push(1);
                if (state.filterData.type[2]) type1.push(2);
                if (state.filterData.type[3]) type1.push(3);
                const res: any = await apiService.excel.searchList(
                    state.currentPage,
                    state.perPage,
                    state.filterData.searchType,
                    dateFormat(new Date(global.searchDate[0])),
                    dateFormat(new Date(global.searchDate[1])),
                    type1.join(","),
                    state.filterData.searchContent,
                    checkedIdx ? checkedIdx.join(",") : null,
                );
                if (res.status === 200) {
                    const blob = res.data;
                    const fileUrl = URL.createObjectURL(blob);
                    const link = document.createElement("a");

                    link.download =
                        "검색관리_" +
                        dateFormat(new Date(global.searchDate[0])) +
                        " - " +
                        dateFormat(new Date(global.searchDate[1])) +
                        ".xlsx";
                    link.href = fileUrl;
                    link.click();
                    URL.revokeObjectURL(fileUrl);
                    return alert("다운로드 완료 되었습니다.");
                } else {
                    console.error(res);
                    alert("다운로드 중 오류가 발생했습니다.");
                }
            };

            const showImg = (value: any) => {
                modal.title = "검색이미지";
                modal.content.main.data = "";
                modal.content.img.data = value ? value : require("@/assets/common/NoImg.png");
                state.isModalOpen = true;
            };

            const selectStatus = (idx: number) => {
                if (idx === 0) state.filterData.sns = snsList.map((item) => item.idx);
                else state.filterData.sns = [idx];
                state.selectStatus = idx;
                getSearchList();
            };

            const checkAllList = () => {
                if (state.checkAll) state.checkList = list.data.map((item) => item.idx);
                else state.checkList = [];
            };

            return {
                global,
                user,
                state,
                modal,
                list,
                snsList,
                searchList,
                selectDate,
                handlePageChange,
                modalClose,
                numberFormat,
                resultBtn,
                moreText,
                checkAllList,
                deleteList,
                deleteLists,
                filterSearch,
                formatDate,
                excelDownLoad,
                author,
                showImg,
                selectStatus,
            };
        },
    };
</script>
<style>
    #board_layer .board_table td .board_thumb,
    #board_layer .board_table td .board_thumb img {
        max-width: 60px;
        max-height: 53px;
        margin: 0 auto;
        object-fit: contain;
    }

    .col_spinner .spinner_wrap {
        padding: 10px 0;
    }

    .col_spinner .spinner {
        width: 20px;
        height: 20px;
    }

    .pop_sns_box > span > img {
        width: 32px;
    }
</style>

<style scoped>
    .monitoring_menu ul li {
        cursor: default;
    }
</style>
